import { PROFILE_PICTURE_TOOL } from '@quicktools/shared-components';

export const BASE_URL = `${process.env.NX_DEPLOY_PATH}${process.env.NX_DEPLOY_SUFFIX}`;
export const VERSION = process.env.NX_APP_VERSION;

export const TOOL_NAME = PROFILE_PICTURE_TOOL.id;

export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;

export const AI_API = process.env.NX_APP_AI;
export const AI_TOKEN = process.env.NX_APP_AI_TOKEN;
export const AI_UPLOAD_TOKEN = process.env.NX_APP_AI_UPLOAD_TOKEN;
export const RECAPTCHA_SITE_KEY = process.env.NX_RECAPTCHA_SITE_KEY;
export const QUICKTOOLS_API_BASE_URL = process.env.NX_QUICKTOOLS_API_BASE_URL;

export const PICSART_API = process.env.NX_PICSART_API;

export const canonicalPath = 'design/profile-picture/';

export const appConfig = {
  toolName: PROFILE_PICTURE_TOOL.id,
  accept: 'image/heic,image/*',
  multiple: false,
  logoUrl: 'https://cdn140.picsart.com/97413594040368613870.svg',
  loadingImageUrl: 'https://cdn140.picsart.com/11081722040317240991.png',
  heroBannerImageUrl: 'https://cdn140.picsart.com/92498658897698573682.webp',
  cardImageSection: [
    {
      src: 'https://cdn140.picsart.com/73662408202230067494.svg',
      alt: 'Clock with checkmark inside',
    },
    {
      src: 'https://cdn140.picsart.com/06860572220467539958.svg',
      alt: 'Pricetag free',
    },
    {
      src: 'https://cdn140.picsart.com/25319916661662563856.svg',
      alt: 'Desktop and mobile with checkmark',
    },
  ],
} as const;
